const data = {
  respuesta: [
    {
      codProducto: 123, 
      descripcion: 'PTCUF_XD',
      cantidad: 3,
      precioUnitario: 10,
      descuento: 0,
      cuota: 556,
      total: 30,
      idCliente: 1 
    },
    {
      codProducto: 1234, 
      descripcion: 'PTCUF_XD*2',
      cantidad: 2,
      precioUnitario: 25,
      descuento: 10,
      cuota: 567,
      total: 50,
      idCliente: 1 
    }
  ],
  meta: {
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    total: 1
  },
  blnError: false,
  codError: null,
  msgError: null
}

export default data
